<div>
  <tui-icon class="mb-2" data-testid="card-button-icon" [icon]="icon" />
  <p class="text-lg font-medium">{{ title }}</p>
  <p class="text-sm text-text-tertiary">{{ description }}</p>
</div>
<tui-icon class="ml-auto shrink-0 self-center text-foreground-quaternary" icon="@tui.chevron-right" />
